import { api } from "../../services/api"
import { listNotificationApi, listAllReportApi, listRegionApi, listUserApi, listCSSUserApi, deleteUserApi }  from "../../services/apiVariables" 
import { GetMonthYear } from '@src/function.js'

// ----------------------Notification----------------------------
export function NotificationDetails() {
    return (dispatch) => { 
     dispatch({ type: 'Notification_LOADING' }) 
    api(listNotificationApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'Notification_SUCCESS', data }),
           error => dispatch({ type:'Notification_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}
export function ReportDetails(offset) {
    return (dispatch) => { 
     dispatch({ type: 'Report_LOADING' }) 
      listAllReportApi.addOffset = offset
    api(listAllReportApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'Report_SUCCESS', data }),
           error => dispatch({ type:'Report_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}

export function RegionDetails() {
   return (dispatch) => { 
     dispatch({ type: 'Region_LOADING' }) 
    api(listRegionApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'Region_SUCCESS', data }),
           error => dispatch({ type:'Region_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}

export function UserDetails() {
   return (dispatch) => { 
     dispatch({ type: 'User_LOADING' }) 
    api(listUserApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'User_SUCCESS', data }),
           error => dispatch({ type:'User_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}

export function CSSUserDetails() {
   return (dispatch) => { 
     dispatch({ type: 'CssUser_LOADING' }) 
    api(listCSSUserApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'CssUser_SUCCESS', data }),
           error => dispatch({ type:'CssUser_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}


export function actionDeleteUser (offset) {
   return (dispatch) => {  
    dispatch({ type: 'deleteUser_LOADING' }) 
     deleteUserApi.addOffset = offset
    api(deleteUserApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'deleteUser_SUCCESS', data }),
           error => dispatch({ type:'deleteUser_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}